import { DataProvider } from 'react-admin'
import { throwNotSupported } from '../../../dataProvider'
import { uncachedClient } from '../../../stackGqlClient'
import { gql } from '@apollo/client'

interface PublisherNode {
  databaseId: string
  name: string
  hostname: string
  organization: { databaseId: string }
}

const publisherProvider: DataProvider = {
  getList: async (_resource, { sort, pagination, filter }) => {
    const { order } = sort || {}
    const { page, perPage } = pagination || {}
    const { id, q } = filter || {}

    return uncachedClient
      .query({
        query: gql`
          query (
            $id: String
            $page: Int
            $perPage: Int
            $order: String
            $q: String
          ) {
            viewer {
              ... on OrgUser {
                publishers(
                  id: $id
                  page: $page
                  perPage: $perPage
                  orderDirection: $order
                  searchQuery: $q
                ) {
                  nodes {
                    databaseId
                    name
                    hostname
                    organization {
                      databaseId
                    }
                  }
                  pageInfo {
                    totalPages
                    totalCount
                  }
                }
              }
            }
          }
        `,
        variables: {
          page,
          perPage,
          order,
          id,
          q
        }
      })
      .then((result) => {
        const { totalCount } = result.data.viewer.publishers.pageInfo
        const data = result.data.viewer.publishers.nodes
          .map(parsePublisher)
          .filter(Boolean)
        return {
          data,
          total: totalCount
        }
      })
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

const parsePublisher = (publisher: PublisherNode) => {
  if (!publisher) return null

  const { databaseId, ...rest } = publisher

  return {
    id: databaseId,
    ...rest
  }
}

export default publisherProvider
